export const API_MEASURE = 'measures'
export const API_MEETING = 'meetings'
export const API_ATTRIBUTE = 'attributes'
export const API_APPOINTMENT_CHANNEL = 'appointment-channels'
export const API_PROJECT = 'projects'
export const API_GROUP = 'groups'
export const API_STAFF = 'staff'
export const API_PERMISSION = 'permissions'
export const SUMMARY_PERIODS = 'summary_periods'
export const API_DASHBOARD = 'dashboard'
export const API_AUTH = 'user/auth'
export const ACHIEVEMENT_PLAN = 'achievement-plan'
export const APPOINTMENT_PLAN = 'appointment-plan'
export const API_EVIDENCE = 'evidence'
export const API_CAMPAIGN = 'campaigns'
export const CHART = 'chart'
export const PROGRESS_APPOINTMENTS = 'progress-appointments'
export const NEW = 'new'
export const FOLLOW = 'follow'
export const APPOINTMENT_PROGRESS = 'appointment-progress'
export const COST_PROGRESS = 'cost-progress'
export const TOTAL_CHART = 'total-chart'
export const PERCENTAGE_SETTING = 'percentageSetting'
export const ACHIEVEMENT_DATE_SETTING = 'achievementDateSetting'
export const ASSUMED_ALLOCATION_RATE_SETTING = 'assumedAllocationRateSetting'
export const API_INDUSTRY = 'industry'
export const EDITABLE = 'editable'
export const API_GOOGLE_SPREADSHEET = 'google_spreadsheet'
export const API_CUSTOM_ITEM = 'custom-items'
export const API_HIDDEN_ITEM = 'hidden-items'
export const API_ASSIGN_SETTING = 'assign_setting'



// WEBPACK FOOTER //
// ./src/common/api.constants.js